module.exports = __webpack_public_path__ + "static/media/OPJEMS.ff819e27.png";